












import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import OptionsData from '@/ts/OptionsData';

@Component({
    methods: {
        ...mapActions([Actions.POST_OPTION_IMAGE]),
    },
})
export default class OptionImage extends Vue {
    @Prop() public optionsData!: OptionsData;
    // private imageData: string = '';
    private optionImageData: File;
    private optionImageBase64: string;

    constructor() {
        super();
    }

    public selectFile(e: Event) {
        this.optionImageData = (e.target as HTMLInputElement).files[0];

        // convert to base64
        const reader = new FileReader();
        reader.onload = () => {
            // this.imageData = reader.result as string;
            this.optionImageBase64 = reader.result.toString();
        };
        reader.readAsDataURL(this.optionImageData);
    }

    public imageUpload() {
        this.$store.dispatch(Actions.POST_OPTION_IMAGE, this.optionImageBase64);
    }
}
